/**
 * Converts pounds to kilograms, rounding up to 2 decimal places.
 *
 * @param {number} pounds - The weight in pounds to be converted.
 * @returns {number} The weight in kilograms.
 * @throws {TypeError} If the input is not a number.
 * @throws {RangeError} If the input is a negative number.
 *
 * @example
 * // returns 0.45
 * convertPoundsToKilograms(1);
 *
 * @example
 * // returns 2.27
 * convertPoundsToKilograms(5);
 */
export const convertPoundsToKilograms = pounds => {
  const kilograms = parseInt(pounds) * 0.453592;
  const decimalPlaces = 2;
  const roundedKilograms = Math.round(kilograms * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
  return roundedKilograms;
};

export const convertKilogramsToPounds = kilograms => {
  return Math.round(kilograms * 2.20462);
};

export const convertCentimetersToFeetAndInches = centimeters => {
  const totalInches = centimeters / 2.54;
  const decimalFeet = totalInches / 12;
  const outputFeet = Math.floor(decimalFeet);
  const remainingInches = Math.round((decimalFeet - Math.floor(outputFeet)) * 12);
  return {
    feet: outputFeet,
    inches: remainingInches,
  };
};

/**
 * Converts a measurement in feet and inches to centimeters rounded up to 2 decimal places.
 *
 * @param {number} feet - The number of feet in the measurement.
 * @param {number} inches - The number of inches in the measurement.
 * @returns {number} The measurement converted to centimeters.
 *
 * @example
 * convertFeetAndInchesToCentimeters(5, 6); // returns 167.64
 * convertFeetAndInchesToCentimeters(0, 12); // returns 30.48
 * convertFeetAndInchesToCentimeters(6, 0); // returns 182.88
 */
export const convertFeetAndInchesToCentimeters = (feet, inches) => {
  const totalInches = feet * 12 + inches;
  const centimeters = totalInches * 2.54;
  const decimalPlaces = 2;
  const roundedCentimeters = Math.round(centimeters * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
  return roundedCentimeters;
};
